<template>
  <div
    v-if="reloadFlag"
    :id="colsOptions.uid"
    :class="[colsOptions.uid, colsOptions.rows ? '' : 'last_level_col', isActiveCol ? 'active-col' : '']"
    draggable="true"
    @drop.stop="handleColsDragover($event, colsOptions.uid)"
    @dragover.stop.prevent
    :align-self="colsOptions.alignSelf"
    :style="rowStyle"
    @mouseenter.stop="mouseenterEv"
    @mouseleave.stop="mouseleaveEv"
  >
    <!-- 当前col里还有row 需要递归渲染下去 -->
    <div v-if="colsOptions.rows" class="rowBox" style="height: 100%">
      <cx-big-screen-row
        v-for="(item, index) in colsOptions.rows"
        :options="options"
        :zoom="zoom"
        :key="index"
        :rowsOptions="item"
        :myid="myid"
      />
    </div>
    <!-- 当前col下没有row了 渲染当前col内的组件 -->
    <div
      v-else-if="!colsOptions.rows"
      class="componentBox"
      :class="[showAutoLayout ? 'auto-layout' : '']"
      :ref="'componentBox' + colsOptions.uid"
    >
      <div
        @mouseenter="mouseenterEv"
        @mouseleave="mouseleaveEv"
        @click="colsClickEv"
        :ref="'componentBox_after' + colsOptions.uid"
        :class="[
          'componentBox_after',
          colsOptions.displayFlex ? 'displayFlex' : '',
          direction,
          isActiveCol ? 'activeCol' : '',
          'componentBox_after' + colsOptions.uid
        ]"
        :id="'componentBox_after' + colsOptions.uid"
        :style="getAfterStyle"
      >
        <template v-if="colsOptions.elementOptions.length">
          <div class="auto-layout-container" v-if="showAutoLayout" :style="getAutoLayoutContentStyle">
            <template v-for="(elementOptions, index) in colsOptions.elementOptions">
              <vueDragResizable
                v-if="elementOptions.width && elementOptions.height && elementOptions.innerElement !== 'undefined'"
                :class="[
                  `container_id_${myid.container_id}-rect_id_${myid.rect_id}-uid_${colsOptions.uid}-elementInLayoutId_${elementOptions.elementInLayoutId}`,
                  direction,
                  elementOptions.specialClassName ? elementOptions.specialClassName : '',
                  elementOptions.isActive ? 'active' : ''
                ]"
                :key="'layoutComponent' + elementOptions.elementInLayoutId"
                :data-innerElement="'element is:' + elementOptions.innerElement"
                :parentW="getParentW"
                :parentH="getParentH"
                :w="elementOptions.width"
                :h="elementOptions.height"
                :x="Number(elementOptions.left)"
                :y="Number(elementOptions.top)"
                :uid="colsOptions.uid"
                :parent="true"
                :zoom="zoom"
                :elementInLayoutId="elementOptions.elementInLayoutId"
                :elementName="elementOptions.innerElement"
                :active="elementOptions.isActive"
                :isShowModuleHandles="false"
                :draggable="elementOptions.draggable"
                :resizable="checkResizable(elementOptions)"
                :options="elementOptions"
                :rectId="myid.rect_id"
                :shape="elementOptions.innerElement"
                v-on:resizing="resizingEv"
                v-on:resizeStop="resizestopEv"
                v-on:dragStop="dragstopEv"
                v-on:activated="activeEv"
                v-on:delElement="delElementEv"
                @refLineParams="getRefLineParams"
                @click.stop.prevent
                @mouseup.stop.prevent
                @mousedown.stop.prevent
                :handles="checkHandles(elementOptions)"
                :style="getSpecialStyle(elementOptions, index)"
                :myId="{ ...myid, uid: colsOptions.uid, elementInLayoutId: elementOptions.elementInLayoutId }"
              >
                <component
                  style="min-height: 100%"
                  :myid="{ ...myid, uid: colsOptions.uid, elementInLayoutId: elementOptions.elementInLayoutId }"
                  :is="elementOptions.innerElement"
                  :active="elementOptions.isActive"
                  :options="elementOptions"
                  :class="['rect']"
                ></component>
              </vueDragResizable>
            </template>
          </div>
          <template v-else>
            <template v-for="(elementOptions, index) in colsOptions.elementOptions">
              <vueDragResizable
                v-if="elementOptions.width && elementOptions.height && elementOptions.innerElement !== 'undefined'"
                :class="[
                  `container_id_${myid.container_id}-rect_id_${myid.rect_id}-uid_${colsOptions.uid}-elementInLayoutId_${elementOptions.elementInLayoutId}`,
                  direction,
                  elementOptions.specialClassName ? elementOptions.specialClassName : '',
                  elementOptions.isActive ? 'active' : ''
                ]"
                :key="'layoutComponent' + elementOptions.elementInLayoutId"
                :data-innerElement="'element is:' + elementOptions.innerElement"
                :parentW="getParentW"
                :parentH="getParentH"
                :data-zxf="elementOptions.width"
                :w="elementOptions.width"
                :h="elementOptions.height"
                :x="Number(elementOptions.left)"
                :y="Number(elementOptions.top)"
                :uid="colsOptions.uid"
                :parent="true"
                :zoom="zoom"
                :elementInLayoutId="elementOptions.elementInLayoutId"
                :elementName="elementOptions.innerElement"
                :active="elementOptions.isActive"
                :isShowModuleHandles="false"
                :draggable="elementOptions.draggable"
                :resizable="checkResizable(elementOptions)"
                :options="elementOptions"
                :rectId="myid.rect_id"
                :shape="elementOptions.innerElement"
                v-on:resizing="resizingEv"
                v-on:resizeStop="resizestopEv"
                v-on:dragStop="dragstopEv"
                v-on:activated="activeEv"
                v-on:delElement="delElementEv"
                @refLineParams="getRefLineParams"
                @childClickBubbleParent="childClickBubbleParent"
                @click.stop.prevent
                @mouseup.stop.prevent
                @mousedown.stop.prevent
                :handles="checkHandles(elementOptions)"
                :style="getSpecialStyle(elementOptions, index)"
                :myId="{ ...myid, uid: colsOptions.uid, elementInLayoutId: elementOptions.elementInLayoutId }"
                :clickBubble="clickBubble"
              >
                <component
                  style="min-height: 100%"
                  :myid="{ ...myid, uid: colsOptions.uid, elementInLayoutId: elementOptions.elementInLayoutId }"
                  :is="elementOptions.innerElement"
                  :options="elementOptions"
                  :active="elementOptions.isActive"
                  :class="['rect']"
                ></component>
              </vueDragResizable>
            </template>
          </template>
        </template>
        <p class="emptyColText" v-else-if="!this.isBigScreenPreview()">从左侧工具栏拖拽添加模块</p>
      </div>
      <!--辅助线 -->
      <template>
        <span
          class="ref-line v-line"
          v-for="item in vLine"
          :key="item.id"
          v-show="item.display"
          :style="{
            left: item.position,
            top: item.origin,
            height: item.lineLength
          }"
        />
        <span
          class="ref-line h-line"
          v-for="item in hLine"
          :key="item.id"
          v-show="item.display"
          :style="{
            top: item.position,
            left: item.origin,
            width: item.lineLength
          }"
        />
      </template>
      <!--辅助线END-->
      <!-- 克隆模式下的蒙版 -->
      <div
        v-if="clonePatternStatu && ids.rect_id === myid.rect_id"
        class="col-clone-shade"
        :class="getCloneType"
        @click="selectCol(colsOptions.uid)"
      >
        <span v-if="ids.uid !== colsOptions.uid" :class="getIconType" class="icon">
          <span v-if="isOrderPattern" style="line-height: 14px; padding-right: 1px">{{ getIconNum }}</span>
        </span>
      </div>
      <!-- 克隆模式下的蒙版 END-->
    </div>
    <topSettingBtn
      :ref="colsOptions.uid + 'topSettingBtn'"
      v-if="isActiveCol && !this.isBigScreenPreview() && !clonePatternStatu"
      :isActiveCol="isActiveCol"
      @activeCol="colsClickEv"
      :ids="ids"
      :myid="myid"
      :uid="colsOptions.uid"
      :options="options"
      :colsOptions="colsOptions"
      @mouseenter="mouseenterEv"
      @mouseleave="mouseleaveEv"
    />
    <dragBtn
      v-if="isActiveCol && !this.isBigScreenPreview() && !clonePatternStatu"
      :zoom="zoom"
      :myid="myid"
      :uid="colsOptions.uid"
      :options="options"
      position="left"
      @mouseenter="mouseenterEv"
      @mouseleave="mouseleaveEv"
    />
    <dragBtn
      v-if="isActiveCol && !this.isBigScreenPreview() && !clonePatternStatu"
      :zoom="zoom"
      :myid="myid"
      :uid="colsOptions.uid"
      :options="options"
      position="right"
      @mouseenter="mouseenterEv"
      @mouseleave="mouseleaveEv"
    />
    <dragBtn
      v-if="isActiveCol && !this.isBigScreenPreview() && !clonePatternStatu"
      :zoom="zoom"
      :myid="myid"
      :uid="colsOptions.uid"
      :options="options"
      position="top"
      @mouseenter="mouseenterEv"
      @mouseleave="mouseleaveEv"
    />
    <dragBtn
      v-if="isActiveCol && !this.isBigScreenPreview() && !clonePatternStatu"
      :zoom="zoom"
      :myid="myid"
      :uid="colsOptions.uid"
      :options="options"
      position="bottom"
      @mouseenter="mouseenterEv"
      @mouseleave="mouseleaveEv"
    />
  </div>
</template>

<script>
import { getSyetemModuleJson } from "@/utils/initEv.js"
import { _debounce, _throttle } from "utils/index"
import componentsMixin from "./componentsMixin.js"
import swiperComponent from "materials/swiper/render/swiper-component.vue"
import dragBtn from "./dragBtn.vue"
import topSettingBtn from "./topSettingBtn.vue"
import { getDefaultColsUidInLayoutComponent, isExist } from "utils"
import animateMixin from "utils/event/animateMixin.js"
import eventMixin from "utils/event/eventMixin.js"
import { CATEGORY_MODE } from "@/consts/index.js"
export default {
  name: "cx-col",
  mixins: [componentsMixin, animateMixin, eventMixin],
  components: { swiperComponent, dragBtn, topSettingBtn },
  props: {
    colsOptions: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    zoom: {
      type: Number,
      default: 1
    },
    myid: {
      type: Object,
      default: null
    }
  },
  watch: {
    colsOptions: {
      deep: true,
      handler(o, n) {
        if (!this.colsOptions.rows) {
          const el = this.$refs["componentBox_after" + this.colsOptions.uid]
          if (el) {
            const { offsetHeight, offsetWidth } = el
            let status = 0
            if (el && offsetWidth !== 0) {
              if (this.getParentW !== offsetWidth) status++
              this.getParentW = offsetWidth
            }
            if (el && offsetHeight !== 0) {
              if (this.getParentH !== offsetHeight) status++
              this.getParentH = offsetHeight
            }
            // if (status) this.reload()
          }
        }
      }
    },
    "colsOptions.uid": {
      handler: function (n, o) {
        // 可能是切换了样式
        this.reloadFlag = false
        setImmediate(() => {
          this.reloadFlag = true
        })
      },
      immediate: true,
      deep: false
    },
    reloadFlag(newVal) {
      if (!newVal) {
        return
      }
      // 自由布局重新渲染后 绑定鼠标事件
      this.$nextTick(() => {
        if (this.$el.nodeType !== 1) {
          return
        }
        this.currentEl = this.$el.getElementsByClassName("componentBox_after")[0]
        if (this.currentEl) {
          this.mouseoverHandleAnimate()
          this.clickHandleAnimate()
        }
      })
    },
    ids: {
      deep: true,
      handler(n, o) {
        if (n.uid !== this.colsOptions.uid) {
          this.clearAllActiveInCol()
          if (this.$refs[this.colsOptions.uid + "topSettingBtn"]) {
            this.$refs[this.colsOptions.uid + "topSettingBtn"].hiddenSetting()
          }
        }
      }
    },
    clonePatternStatu(newVal, oldVal) {
      if (this.ids.rect_id === this.myid.rect_id) {
        if (newVal) {
          this.getAllCols()
        }
        if (!newVal && oldVal) {
          // 被同步的单元格重新进行渲染
          for (let i = 0; i < this.allCols.length; i++) {
            if (this.allCols[i].isChecked) {
              this.reloadFlag = false
              setImmediate(() => {
                this.reloadFlag = true
              })
              break
            }
          }
        }
      }
    }
  },
  data() {
    return {
      activeColCheckStatus: true,
      resizeOb: null,
      getParentW: Infinity,
      getParentH: Infinity,
      isApp: false,
      reloadFlag: true,
      vLine: [],
      hLine: [],
      allCols: [],
      requestAnimation: null,
      clickBubble: false,
      isCol: true
    }
  },
  computed: {
    isClonePattern() {
      return this.$store.state.states.isClonePattern
    },
    isOrderPattern() {
      return this.$store.state.states.isOrderPattern
    },
    clonePatternStatu() {
      return this.isClonePattern || this.isOrderPattern
    },
    isActiveCol() {
      const rectAttr = this.getRectAttribute.call(this, this.ids)
      const active = rectAttr ? rectAttr.active : true
      const flag = this.options.activeCol === this.colsOptions.uid || this.ids.uid === this.colsOptions.uid
      return active && flag
    },
    elementType() {
      return this.$store.state.states.elementType
    },
    ids() {
      return this.$store.state.states.activeID
    },
    isLayout() {
      return this.$store.state[this.request_prefix].page.pageLayoutType
    },
    leftMenuDragStatus() {
      return this.$store.state.states.leftMenuDragStatus
    },
    getCloneType() {
      let className = ""
      for (let i = 0; i < this.allCols.length; i++) {
        if (this.allCols[i].uid === this.colsOptions.uid) {
          className = this.allCols[i].isChecked ? "checked" : ""
          break
        }
      }
      return className
    },
    getIconType() {
      let className = "icon-portal-adjustment"
      for (let i = 0; i < this.allCols.length; i++) {
        if (this.allCols[i].uid === this.colsOptions.uid) {
          if (this.isClonePattern) {
            className = this.allCols[i].isChecked ? "icon-portal-check-small" : "select-icon"
          } else {
            className = this.allCols[i].isChecked ? "icon-check-round" : "select-icon-round"
          }
          break
        }
      }
      return className
    },
    getIconNum() {
      const checkedCol = this.allCols.find(col => col.uid === this.colsOptions.uid)
      return checkedCol.isChecked ? checkedCol.order : ""
    },
    showRightBtn: {
      get() {
        return this.$store.state.states.showRightBtn
      },
      set(newVal) {
        this.$store.commit("states/changeRightBtnStatu", newVal)
      }
    },
    rowStyle() {
      let height =
        typeof this.colsOptions.height === "string" ? this.colsOptions.height : this.colsOptions.height + "px"
      const boxOpt = this.colsOptions.componentBoxOptions
      let borderW = ""
      if (Array.isArray(boxOpt.borderWidth)) {
        boxOpt.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${boxOpt.borderWidth}px`
      }
      let baseStyle =
        !this.colsOptions.rows || this.colsOptions.rows.length === 0
          ? {}
          : {
              ...this.bgStyle,
              "border-style": boxOpt.borderStyle,
              // "border-color": boxOpt.borderIsThemeColor
              //   ? this.themeColor
              //   : boxOpt.borderColor.color
              //   ? boxOpt.borderColor.color
              //   : boxOpt.borderColor,
              "border-color": this.$parseColor(boxOpt.borderColor, {
                isThemeColor: boxOpt.borderIsThemeColor
              }),
              "border-width": borderW,
              "border-radius":
                boxOpt.borderTopLeftRadius +
                "px " +
                boxOpt.borderTopRightRadius +
                "px " +
                boxOpt.borderBottomRightRadius +
                "px " +
                boxOpt.borderBottomLeftRadius +
                "px"
            }
      return {
        ...baseStyle,
        ...this.getColsBorder,
        width: this.colsOptions.width,
        height: height,
        position: "relative",
        "padding-top": `${this.clonePatternStatu ? 0 : boxOpt.paddingTop}px`,
        "padding-bottom": `${this.clonePatternStatu ? 0 : boxOpt.paddingBottom}px`,
        "padding-left": `${this.clonePatternStatu ? 0 : boxOpt.paddingLeft}px`,
        "padding-right": `${this.clonePatternStatu ? 0 : boxOpt.paddingRight}px`
      }
    },
    showAutoLayout() {
      return this.colsOptions.componentBoxOptions.showAutoLayout
    },
    direction() {
      return this.colsOptions.componentBoxOptions.direction
    },
    animateStyle() {
      return this.getAnimateVariableStyle(this.colsOptions.componentBoxOptions, {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        uid: this.colsOptions.uid
      })
    },
    getAfterStyle() {
      const boxOpt = this.colsOptions.componentBoxOptions
      let borderW = ""
      if (Array.isArray(boxOpt.borderWidth)) {
        boxOpt.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${boxOpt.borderWidth}px`
      }
      let res = {
        "box-shadow": this.boxShadowStyle,
        width: "100%",
        height: "100%"
      }
      let baseStyle =
        this.colsOptions.rows && this.colsOptions.rows.length > 0
          ? {}
          : {
              ...this.bgStyle,
              "border-style": boxOpt.borderStyle,
              // "border-color": boxOpt.borderIsThemeColor
              //   ? this.themeColor
              //   : boxOpt.borderColor.color
              //   ? boxOpt.borderColor.color
              //   : boxOpt.borderColor,
              "border-color": this.$parseColor(boxOpt.borderColor, {
                isThemeColor: boxOpt.borderIsThemeColor
              }),
              "border-width": borderW,
              "border-radius":
                boxOpt.borderTopLeftRadius +
                "px " +
                boxOpt.borderTopRightRadius +
                "px " +
                boxOpt.borderBottomRightRadius +
                "px " +
                boxOpt.borderBottomLeftRadius +
                "px",
              opacity: boxOpt.opacity / 100
            }
      Object.assign(res, {
        ...baseStyle,
        ...this.animateStyle
      })
      // }
      switch (boxOpt.bgColorType) {
        case "纯色":
          Object.assign(res, {
            background: boxOpt.bgColor
          })
          break
        case "线性渐变":
          Object.assign(res, {
            background: "linear-gradient(to top, " + boxOpt.bgStartColor + "," + boxOpt.bgEndColor + ")"
          })
          break
        case "径向渐变":
          Object.assign(res, {
            background:
              "-webkit-radial-gradient(center,closest-corner," + boxOpt.bgStartColor + "," + boxOpt.bgEndColor + ")"
          })
          break
        case "图片":
          Object.assign(res, {
            "--background-image": "url(" + boxOpt.imgSrc + ")",
            "--background-opacity": boxOpt.bgOpacity,
            "--background-repeat": boxOpt.repeatType,
            "--background-size": boxOpt.clipSize,
            "--background-position": boxOpt.alignType
          })
          break
        default:
          break
      }
      return res
    },
    getColsBorder() {
      return {
        outline: this.isActiveCol
          ? "2px solid var(--themeColor)"
          : this.colsOptions.elementOptions.length > 0 || this.colsOptions.rows || this.isBigScreenPreview()
          ? "none"
          : "1px dashed rgba(0, 0, 0, 0.4)"
      }
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let options = this.colsOptions.componentBoxOptions
      if (!options || !options.boxShadowColor) {
        return
      }
      if (Array.isArray(options.boxShadowH)) {
        options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${options.boxShadowH[index]}px ${options.boxShadowV[index]}px ${options.boxShadowBlur[index]}px ${options.boxShadowSpread[index]}px ${this.$parseColor(options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${options.boxShadowH}px ${options.boxShadowV}px ${options.boxShadowBlur}px ${options.boxShadowSpread}px ${this.$parseColor(options.boxShadowColor)}`
      }
      return tmpStyle
    },
    getSpecialStyle() {
      return function (rect, index) {
        // 自动布局内部为定位,所以padding需要放在外层
        let elementOptionsActive = this.colsOptions.uid === this.ids.uid ? true : false
        if (rect.innerElement && rect.innerElement === "cxAutoLayout") {
          let borderW = ""
          if (Array.isArray(rect.borderWidth)) {
            rect.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
          } else {
            borderW += ` ${rect.borderWidth}px`
          }

          let padding = `${rect.padding}px`
          let boxShadow = `0 0 0 ${padding}   rgba(56, 154, 30, 0.4)  inset`
          if (!rect.textPaddingTypeFlag || rect.textPaddingTypeFlag === 2) {
            padding = ` ${rect.paddingTop}px  ${rect.paddingRight}px  ${rect.paddingBottom}px  ${rect.paddingLeft}px`
            boxShadow = `0 -${rect.paddingBottom}px 0 0   rgba(56, 154, 30, 0.4)  inset, -${rect.paddingRight}px 0 0 0    rgba(56, 154, 30, 0.4)   inset , ${rect.paddingLeft}px 0 0 0  rgba(56, 154, 30, 0.4)  inset, 0 ${rect.paddingTop}px 0 0   rgba(56, 154, 30, 0.4)  inset`
          }
          return {
            padding: padding,
            boxShadow: boxShadow,
            "border-top-left-radius": rect.borderTopLeftRadius + "px",
            "border-top-right-radius": rect.borderTopRightRadius + "px",
            "border-bottom-right-radius": rect.borderBottomRightRadius + "px",
            "border-bottom-left-radius": rect.borderBottomLeftRadius + "px",
            "border-style": rect.borderStyle,
            // "border-color": rect.borderIsThemeColor ? this.themeColor : rect.borderColor,
            "border-color": this.$parseColor(rect.borderColor, {
              isThemeColor: ect.borderIsThemeColor
            }),
            "border-width": borderW
          }
        } else if (this.showAutoLayout) {
          let style = {}
          let margin = this.colsOptions.componentBoxOptions.marginBottom
            ? this.colsOptions.componentBoxOptions.marginBottom
            : 0
          if (index + 1 < this.colsOptions.elementOptions.length) {
            switch (this.direction) {
              case "vertical": //垂直对齐
                style.marginBottom = margin + "px"
                style.boxShadow = elementOptionsActive ? `0 ${margin}px 0 0 rgba(198, 18, 158, 0.4)` : undefined

                break
              case "horizon": //水平对齐
                style.marginRight = margin + "px"
                style.boxShadow = elementOptionsActive ? `${margin}px 0 0 0 rgba(198, 18, 158, 0.4) ` : undefined
                break
            }
          }
          style.verticalAlign = this.direction === "horizon" ? this.colsOptions.componentBoxOptions.alignPositionV : ""
          if (this.direction === "vertical") {
            switch (this.colsOptions.componentBoxOptions.alignPositionH) {
              case "left":
                style.marginLeft = "0"
                style.marginRight = "auto"
                break
              case "center":
                style.marginLeft = "auto"
                style.marginRight = "auto"
                break
              case "right":
                style.marginLeft = "auto"
                style.marginRight = "0"
                break
            }
          }
          return style
        }
      }
    },
    showComponentBoxSetting() {
      const hideNames = ["searchComponentPlugin", "loginLayoutComponent", "loginEngineComponentPlugin", "appNavPlugin"]
      if (this?.options?.pluginName?.length) {
        return this?.options?.pluginName?.length
          ? this.options.pluginName.find(it => {
              return hideNames.find(_it => _it === it)
            })
          : false
      } else if (this?.options?.name === "超星头像") {
        //超星头像屏蔽单元格
        return true
      }
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    bgStyle() {
      const boxOpt = this.colsOptions.componentBoxOptions
      let containerBg = {
        backgroundImage: ""
      }
      let background
      if (!boxOpt.background || !Array.isArray(boxOpt.background)) {
        background = [
          {
            type: "img",
            imgUrl: boxOpt.imgSrc,
            clipSize: boxOpt.clipSize,
            repeatType: boxOpt.repeatType,
            alignType: boxOpt.alignType
          }
        ]
      } else {
        background = boxOpt.background
      }
      background.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = bg.clipSize
            containerBg.backgroundPosition = bg.alignType
            containerBg.backgroundRepeat = bg.repeatType
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
            }
            break
          default:
        }
      })
      return containerBg
    },
    getAutoLayoutContentStyle() {
      let style = {}
      if (!this.colsOptions.componentBoxOptions.showAutoLayout) {
        return style
      }
      style.width = this.contentWidth + "px"
      // 水平方向的定位
      switch (this.colsOptions.componentBoxOptions.alignPositionH) {
        case "left":
          style.left = "0px"
          style.right = "auto"
          break
        case "center":
          style.left = "50%"
          style.right = "auto"
          break
        case "right":
          style.left = "auto"
          style.right = "0px"
          break
      }
      // 水平方向的定位
      switch (this.colsOptions.componentBoxOptions.alignPositionV) {
        case "top":
          style.top = "0px"
          style.bottom = "auto"
          break
        case "middle":
          style.top = "50%"
          style.bottom = "auto"
          break
        case "bottom":
          style.top = "auto"
          style.bottom = "0px"
          break
      }
      let transform
      if (
        this.colsOptions.componentBoxOptions.alignPositionH === "center" &&
        this.colsOptions.componentBoxOptions.alignPositionV === "middle"
      ) {
        transform = "translate(-50%,-50%)"
      } else if (this.colsOptions.componentBoxOptions.alignPositionH === "center") {
        transform = "translateX(-50%)"
      } else if (this.colsOptions.componentBoxOptions.alignPositionV === "middle") {
        transform = "translateY(-50%)"
      }
      style.transform = transform
      return style
    },
    contentWidth() {
      let contentWidth = 0
      if (this.direction === "horizon") {
        // 水平排列 计算总宽度
        contentWidth = this.getContentWidth(this.colsOptions.elementOptions, contentWidth)
        contentWidth += (this.colsOptions.elementOptions.length - 1) * this.colsOptions.componentBoxOptions.marginBottom
      } else {
        // 垂直排列，计算最大宽度
        contentWidth = this.getMaxContentWidth(this.colsOptions.elementOptions, contentWidth)
      }
      return contentWidth
    },
    contentHeight() {
      let contentHeight = 0
      if (this.direction === "vertical") {
        // 垂直排列，计算总高度
        contentHeight = this.getContentHeight(this.colsOptions.elementOptions, contentHeight)
        contentHeight +=
          (this.colsOptions.elementOptions.length - 1) * this.colsOptions.componentBoxOptions.marginBottom
      } else {
        //  垂直排列，计算最大高度
        contentHeight = this.getMaxContentHeight(this.colsOptions.elementOptions, contentHeight)
      }
      return contentHeight
    }
  },
  mounted() {
    if (!this.colsOptions.rows) {
      const el = this.$refs["componentBox_after" + this.colsOptions.uid]
      if (el && el.offsetWidth !== 0) this.getParentW = el.offsetWidth
      if (el && el.offsetHeigh !== 0) this.getParentH = el.offsetHeight
    }
    this.setParentSize()
    window.addEventListener("message", this.watchColsChange)
    if (this.options.queryColValue && this.colsOptions.elementOptions?.length > 0) {
      this.clickBubble = true
    }
  },
  beforeDestroy() {
    try {
      window.removeEventListener("message", this.watchColsChange)
      if (this.resizeOb && this.$el) this.resizeOb.unobserve(this.$el)
      cancelAnimationFrame(this.requestAnimation)
    } catch (e) {}
  },
  methods: {
    childClickBubbleParent() {
      //自由布局列内部组件点击传递到列点击，实现交互事件点击整个列的效果
      if (this.clickBubble) {
        console.log("childClickBubbleParent", document.getElementById("componentBox_after" + this.colsOptions.uid))
        document.getElementById("componentBox_after" + this.colsOptions.uid).click()
      }
    },
    watchColsChange({ data }) {
      if (this.ids.rect_id === this.myid.rect_id && data.type === "resetOrder") {
        const allCols = JSON.parse(sessionStorage.getItem("allCols"))
        this.$set(this, "allCols", allCols)
      }
    },
    // 获取当前tab下面的所有col
    getAllCols() {
      const allCols = []
      if (this.isClonePattern && !this.ids.uid) return // 没有uid说明选中的是整个布局，只有选中布局中的col才进后续逻辑
      const rectAttr = this.getRectAttribute.call(this, this.ids)
      let { renderOrder, activeIndex, rows, categoryMode } = rectAttr.options
      // 旧数据格式不同的清除重做
      if (Array.isArray(renderOrder)) {
        renderOrder = {}
      }
      const useActiveIndex = categoryMode === CATEGORY_MODE.SAME ? 0 : activeIndex
      let syncColUids = renderOrder?.[useActiveIndex]?.length
        ? renderOrder[useActiveIndex]
        : getDefaultColsUidInLayoutComponent([rows[useActiveIndex]])
      if (this.isClonePattern) {
        syncColUids = [...syncColUids.filter(item => item !== this.ids.uid)]
      }
      for (let i = 0; i < syncColUids.length; i++) {
        const obj = {
          uid: syncColUids[i],
          isChecked: true,
          order: i + 1
        }
        allCols.push(obj)
      }
      this.$set(this, "allCols", allCols)
      // 通过这种方式存的原因是 col多次渲染 会造成 allCols为空
      sessionStorage.setItem("allCols", JSON.stringify(allCols))
    },
    // 克隆模式下选择需要克隆的单元格
    selectCol(uid) {
      let allCols = sessionStorage.getItem("allCols")
      allCols = JSON.parse(allCols)
      for (let i = 0; i < allCols.length; i++) {
        if (allCols[i].uid === uid) {
          allCols[i].isChecked = !allCols[i].isChecked
          if (this.isOrderPattern && !allCols[i].isChecked) {
            allCols[i].order = 0
          } else if (this.isOrderPattern && allCols[i].isChecked) {
            const map = {}
            allCols.forEach(col => {
              map[col.order] = true
            })
            let max = 0
            for (let i = 1; i <= allCols.length; i++) {
              if (!map[i]) {
                max = i
                break
              }
            }
            allCols[i].order = max
          }
          break
        }
      }
      this.allCols = allCols
      sessionStorage.setItem("allCols", JSON.stringify(allCols))
    },
    setParentSize(count = 0) {
      this.requestAnimation = requestAnimationFrame(() => {
        if (!this.colsOptions.rows) {
          const el = this.$refs[`componentBox_after${this.colsOptions.uid}`]
          if (el) {
            let ParentWidth = el.offsetWidth
            let parentHeight = el.offsetHeight
            this.getParentW = ParentWidth
            this.getParentH = parentHeight
            this.resizeOb = new ResizeObserver(el => {
              this.getParentW = el[0]?.contentRect?.width || this.getParentW
              this.getParentH = el[0]?.contentRect?.height || this.getParentH
            })
            this.resizeOb.observe(el)
          } else if (count < 10) {
            this.setParentSize(count++)
          }
        }
      })
    },
    checkElementInLayoutPos() {
      const eleW = this.$el.offsetWidth
      const eleH = this.$el.offsetHeight
      const uid = this.colsOptions
      this.colsOptions.elementOptions &&
        this.colsOptions.elementOptions.forEach(ele => {
          //组件在单元格外面了
          if (ele.left + ele.width > eleW) {
            //单元格大小大于组件大小
            if (eleW > ele.width) {
              let param = {
                ...this.myid,
                option_name: "left",
                elementInLayoutId: ele.elementInLayoutId,
                uid,
                option_val: elW - ele.width
              }
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
            } else {
              //单元格大小小于组件大小
              let param = {
                ...this.myid,
                option_name: ["left", "width"],
                elementInLayoutId: ele.elementInLayoutId,
                uid,
                option_val: [0, eleW]
              }
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
            }
          }
          if (ele.top + ele.height > eleH) {
            //单元格大小大于组件大小
            if (eleH > ele.height) {
              let param = {
                ...this.myid,
                option_name: "top",
                elementInLayoutId: ele.elementInLayoutId,
                uid,
                option_val: elH - ele.height
              }
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
            } else {
              //单元格大小小于组件大小
              let param = {
                ...this.myid,
                option_name: ["top", "height"],
                elementInLayoutId: ele.elementInLayoutId,
                uid,
                option_val: [0, eleH]
              }
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
            }
          }
        })
    },
    reload: _debounce(function () {
      if (!window.localStorage.getItem("dragLayoutCol")) {
        this.resizeOb?.unobserve(this.$el)
        this.reloadFlag = false
        setImmediate(() => {
          this.reloadFlag = true
          this.setParentSize()
          this.checkElementInLayoutPos()
        })
      } else {
        requestAnimationFrame(() => this.reload())
      }
    }, 50),
    // 初始化col中的组件跳转到详情界面的事件
    initJumpToDetailsPageHandle() {},
    clearAllActiveInCol() {
      //当前单元格中有激活组件时 在进行清除激活操作
      if (this.colsOptions.elementOptions.some(it => it.isActive)) {
        let param = {
          ...this.myid,
          uid: this.colsOptions.uid,
          option_name: "isActive",
          option_val: "delAllActive"
        }
        this.$store.dispatch(this.request_prefix + "/changeLayoutActive", param)
      }
    },
    delTitleActive() {
      let delAllTitleActive = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id
      }
      this.colsOptions.elementOptions.length &&
        this.$store.dispatch(this.request_prefix + "/delAllLayoutTitleActive", delAllTitleActive)
    },
    inColsEv() {
      this.clearAllActiveInCol()
      this.delTitleActive()
      let activeID = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        uid: this.colsOptions.uid
      }
      if (
        this.ids.container_id !== activeID.container_id ||
        this.ids.rect_id !== activeID.rect_id ||
        this.ids.uid !== activeID.uid ||
        this.ids.elementInLayoutId !== activeID.elementInLayoutId
      ) {
        this.$store.commit("states/changeElementType", "colsComponent")
        this.$store.commit("states/changeActiveID", activeID)
      }
    },
    mouseenterEv() {
      if (
        !this.$store.state.states.alignHelperStatus &&
        !localStorage.getItem("multipleComponent") &&
        !localStorage.getItem("preventMouseenterEv")
      ) {
        sessionStorage.setItem("mouseenterObj", this.colsOptions.uid)
        //将当前自由布局组件的选中单元格id设为当前单元格
        this.setCurrColAsActiveCol()
      }
    },
    mouseleaveEv(e) {
      // 鼠标移开的时候做一个延时，在延时期间有mouseenter进来，则不执行mouseleave 操作，解决鼠标悬浮闪烁的问题
      sessionStorage.removeItem("mouseenterObj")
      setTimeout(() => {
        let mouseenterObj = sessionStorage.getItem("mouseenterObj")
        if (mouseenterObj === this.colsOptions.uid) {
          return
        }
        this.$nextTick(() => {
          if (this.options.activeCol === this.colsOptions.uid) {
            this.$changeOptionsEV("", "activeCol", false, null, {
              container_id: this.myid.container_id,
              rect_id: this.myid.rect_id
            })
          }
        })
      }, 50)
    },
    colsClickEv() {
      if (this.isBigScreenPreview()) return
      // 搜索组件不要列设置项 登录组件不要设置项 下拉框组件 不需要设置项 不需要单元格激活效果
      if (this.showComponentBoxSetting) {
        // 点击单元格选中自由布局 否则会无反应
        let ids = {
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id,
          elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
          path: this.myid.path,
        }
        if (isExist(ids.elementInAutoLayoutId)) {
          this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutActive", ids)
        } else {
          this.$store.dispatch(this.request_prefix + "/setActive", ids)
        }
        this.$store.commit("states/changeActiveID", ids)
        this.$store.commit("states/changeElementType", "emptyLayoutComponent")
        return
      }
      this.inColsEv()
      //清除自由布局上下左右框内组件的active
      this.clearTitleOptActive()
      // 关掉右键菜单
      this.showRightBtn = false
    },
    clearTitleOptActive() {
      let delAllTitleActive = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id
      }
      //初次进来 先取消当前cols中的所有元素的active效果
      this.$store.dispatch(this.request_prefix + "/delAllLayoutTitleActive", delAllTitleActive)
    },
    async handleColsDragover(e, id) {
      let attribute = e.dataTransfer.getData("rectAttribute")
      let childItemInfo = sessionStorage.getItem("childItemInfo")
      childItemInfo = JSON.parse(childItemInfo)
      if (childItemInfo.childItemName === "收藏") {
        attribute = JSON.parse(attribute)
        const _attribute = await getSyetemModuleJson(attribute.encId)
        attribute = JSON.stringify(_attribute)
      }
      if (attribute) {
        attribute = JSON.parse(attribute)
        attribute.options.filedMapping = {
          value: null,
          label: null,
          flag: false,
          checked: true
        }
        const preventComponentMap = [
          "cxautolayout", //自动布局组件
          "layoutcomponent", //布局组件
          "swiper" //轮播组件
        ]
        if (preventComponentMap.find(it => attribute.shape.toLowerCase().includes(it))) return
        e.cancelBubble = true
        this.$store.dispatch("menu/unsetActive", { id: "all" })
        // 针对自动布局模式下的组件 添加标识属性
        if (this.colsOptions.componentBoxOptions?.showAutoLayout) {
          attribute.options.isNoConflictCheck = true
        }
        attribute.zIndex = 0
        //获取当前鼠标的left和top
        const { width, height } = attribute.options
        const { offsetWidth, offsetHeight } = this.$el
        let [left, top] = [e.offsetX, e.offsetY]
        ;[attribute.options.left, attribute.options.top] = [left - width / 2, top - height / 2]
        const rightCheck = () => attribute.options.left + attribute.options.width > offsetWidth
        const bottomCheck = () => attribute.options.top + attribute.options.height > offsetHeight
        const leftCheck = () => attribute.options.left < 0
        const topCheck = () => attribute.options.top < 0
        while (rightCheck() || bottomCheck() || leftCheck() || topCheck()) {
          if (rightCheck()) {
            //处理右侧超出去的情况
            if (attribute.options.width <= offsetWidth) {
              attribute.options.left = offsetWidth - attribute.options.width
            } else {
              attribute.options.width = offsetWidth - attribute.options.left
            }
          }
          if (bottomCheck()) {
            //处理下侧超出去的情况
            if (attribute.options.height <= offsetHeight) {
              attribute.options.top = offsetHeight - attribute.options.height
            } else {
              attribute.options.height = offsetHeight - attribute.options.top
            }
          }
          if (leftCheck()) {
            //处理左侧超出去的情况
            attribute.options.left = 0
          }
          if (topCheck()) {
            //处理上侧超出去的情况
            attribute.options.top = 0
          }
        }
        let insertIndex = this.getInsertIndex(e)
        insertIndex = insertIndex < 0 ? 0 : insertIndex
        console.log(insertIndex)
        let param = {
          ...this.myid,
          uid: id,
          elementOptions: attribute.options,
          insertIndex: insertIndex
          // innerElement:attribute.shape
        }

        this.$store.dispatch(this.request_prefix + "/addComponentInLayout", param)
        const { rect_id, uid } = param
        this.$addHistory({
          type: "add",
          stateType: "addCellElement",
          payload: {
            container_id: 0,
            rect_id,
            uid,
            elementInLayoutId: attribute.options.elementInLayoutId
          }
        })
        //默认选中组件
        this.activeEv(
          attribute.options.elementInLayoutId,
          id,
          attribute.options.innerElement,
          this.direction,
          attribute.options
        )
      }
    },
    getInsertIndex(e) {
      let _this = this
      let top = Number(e.offsetY) //鼠标在当前元素上的位置
      let left = Number(e.offsetX)
      let _index = 0
      let targetPosition = e.target.getBoundingClientRect()
      let parentNode = this.getParentNode(e.target)
      if (parentNode.length === 0) {
        _index = _this.colsOptions.elementOptions.length
        return _index
      }
      let parentPosition = parentNode[0].getBoundingClientRect()
      if (_this.colsOptions.componentBoxOptions.direction === "vertical") {
        //垂直方向排列
        const diffTop = (targetPosition.top - parentPosition.top) / this.zoom
        let top1 = 0
        _index = _this.colsOptions.elementOptions.findIndex(item => {
          top1 += item.height + _this.colsOptions.componentBoxOptions.marginBottom
          return top1 > diffTop
        })
        _index = top / targetPosition.height < 0.5 ? _index : _index + 1 //超过元素高度一半显示在下方，否则显示在上方
      }
      if (_this.colsOptions.componentBoxOptions.direction === "horizon") {
        //水平方向排列
        const diffLeft = (targetPosition.left - parentPosition.left) / this.zoom
        let left1 = 0
        _index = _this.colsOptions.elementOptions.findIndex(item => {
          left1 += item.width + _this.colsOptions.componentBoxOptions.marginBottom
          return left1 > diffLeft
        })
        _index = left / targetPosition.width < 0.5 ? _index : _index + 1 // 超过元素宽度一半显示在后方，否则显示在前方
      }
      return _index
    },
    getParentNode(e, res = []) {
      const parentNode = e.parentNode
      if (parentNode && parentNode.classList) {
        let elClasslist = parentNode.classList
        if ([].find.call(elClasslist, it => it === "myContainer")) {
          return []
        } else if ([].find.call(elClasslist, it => it === "auto-layout-container")) {
          res.push(parentNode)
        }
        if (res.length > 0) {
          return res
        } else {
          return this.getParentNode(parentNode, res)
        }
      } else {
        return res
      }
    },
    dragstopEv(rect, elementInLayoutId, uid) {
      const _opt = this.colsOptions.elementOptions.find(it => it.elementInLayoutId === elementInLayoutId)
      const _position = { left: _opt.left, top: _opt.top }
      //如果位置未变 就不修改
      if (
        Object.keys(_position).some(item => {
          return _position[item] !== rect[item]
        })
      ) {
        this.changeVGR(rect, "left", "top", elementInLayoutId, uid)
      }
    },
    resizestopEv(rect, elementInLayoutId, uid) {
      this.changeVGR(rect, "width", "height", elementInLayoutId, uid)
    },
    resizingEv: _throttle(function (rect, elementInLayoutId, uid) {
      this.changeVGR(rect, "width", "height", elementInLayoutId, uid)
    }, 100),
    //封装的修改布局组件中的组件的大小和位置的函数
    changeVGR(rect, change1, change2, elementInLayoutId, uid) {
      let param1 = {
        ...this.myid,
        option_name: [change1, change2],
        elementInLayoutId: elementInLayoutId,
        uid: uid,
        option_val: [rect[change1], rect[change2]]
      }
      this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param1)
    },
    clicked(ev, elementInLayoutId, uid, options) {
      window.localStorage.setItem(
        "tempOffsetPosition",
        JSON.stringify({
          offsetTop: this.$el.offsetTop,
          offsetLeft: this.$el.offsetLeft
        })
      )
      setTimeout(this.handdleChangeActiveInLayout(elementInLayoutId, uid, options), 100)
      //外部组件中设置active的方法有延迟，需要等待一下
    },
    //处理布局组件中元素选中效果
    handdleChangeActiveInLayout(elementInLayoutId, uid, options) {
      const activeID = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        uid: uid,
        elementInLayoutId: elementInLayoutId,
        path: options.path,
        elementInAutoLayoutId: options.elementInAutoLayoutId
      }
      this.$store.commit("states/changeActiveID", activeID)
    },
    setCurrColAsActiveCol() {
      if (this.options.activeCol !== this.colsOptions.uid) {
        this.$changeOptionsEV(this.colsOptions.uid, "activeCol", false, null, {
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id,
          pageId: this.myid.pageId
        })
      }
    },
    activeEv(elementInLayoutId, uid, elementName, direction, options) {
      //将当前自由布局组件的选中单元格id设为当前单元格
      this.setCurrColAsActiveCol()

      this.clicked(null, elementInLayoutId, uid, options)
      //是否对其辅助 都需要设置当前选中元素的active效果
      const setNewActive = {
        ...this.myid,
        uid: uid,
        elementInLayoutId: elementInLayoutId,
        path: options.path,
        option_name: "isActive",
        option_val: true
      }
      if (!this.$store.state.states.alignHelperStatus && !localStorage.getItem("multipleComponent")) {
        let delAllTitleActive = {
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id
        }
        //初次进来 先取消当前cols中的所有元素的active效果
        this.$store.dispatch(this.request_prefix + "/delAllLayoutTitleActive", delAllTitleActive)
        this.colsOptions.elementOptions.length && this.clearAllActiveInCol()
        this.$store.dispatch(this.request_prefix + "/setActive", JSON.parse(JSON.stringify(this.myid)))
        this.$store.dispatch(this.request_prefix + "/changeLayoutActive", setNewActive)
        this.$store.commit("states/changeElementType", elementName)
      } else {
        this.$store.dispatch(this.request_prefix + "/changeLayoutActive", setNewActive)
        this.$store.commit(this.request_prefix + "/ENABLE_ACTIVE", {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id
        })
        //  为了解决自由布局列内的组件多选报错的问题，
        this.$store.commit("states/changeElementType", elementName)

        // if (localStorage.getItem("multipleComponent")) {
        let newArr = JSON.parse(sessionStorage.getItem("tmpComponents")) || []
        newArr.push({
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          uid: uid,
          elementInLayoutId: elementInLayoutId,
          option_name: "isActive",
          option_val: true
        })
        sessionStorage.setItem("tmpComponents", JSON.stringify(newArr))
        // }
      }
    },
    delElementEv(args, elementInLayoutId, uid) {
      let param = {
        ...this.myid,
        elementInLayoutId,
        uid
      }
      this.$store.commit("states/changeElementType", "colsComponent")
      this.$store.dispatch(this.request_prefix + "/delLayoutElement", param)
    },
    // 辅助线回调事件
    getRefLineParams(params) {
      const { vLine, hLine } = params
      let id = 0
      this.vLine = vLine.map(item => {
        item["id"] = ++id
        return item
      })
      this.hLine = hLine.map(item => {
        item["id"] = ++id
        return item
      })
    },
    getContentWidth(elementOptions) {
      let contentWidth = 0
      elementOptions.forEach(element => {
        switch (element.widthType) {
          case "px":
            contentWidth += element.width
            break
          case "%":
            contentWidth += parseInt((this.getParentW * element.width) / 100)
            break
          default:
            contentWidth += element.width
        }
      })
      return contentWidth
    },
    getContentHeight(elementOptions) {
      let contentHeight = 0
      elementOptions.forEach(element => {
        switch (element.heightType) {
          case "px":
            contentHeight += element.height
            break
          case "%":
            contentHeight += parseInt((this.getParentH * element.height) / 100)
            break
          default:
            contentHeight += element.height
        }
      })
      return contentHeight
    },
    getMaxContentWidth(elementOptions) {
      let contentWidth = 0
      elementOptions.forEach(element => {
        switch (element.widthType) {
          case "px":
            contentWidth = Math.max(contentWidth, element.width)
            break
          case "%":
            let _contentWidth = parseInt((this.getParentW * element.width) / 100)
            contentWidth = Math.max(contentWidth, _contentWidth)
            break
          default:
            contentWidth = Math.max(contentWidth, element.width)
        }
      })
      return contentWidth
    },
    getMaxContentHeight(elementOptions) {
      let contentHeight = 0
      elementOptions.forEach(element => {
        switch (element.heightType) {
          case "px":
            contentHeight = Math.max(contentHeight, element.height)
            break
          case "%":
            let _contentHeight = parseInt((this.getParentH * element.height) / 100)
            contentHeight = Math.max(contentHeight, _contentHeight)
            break
          default:
            contentHeight = Math.max(contentHeight, element.height)
        }
      })
      return contentHeight
    },
    // 处理自动布局组件设置尺寸为% 或者auto时候的手柄情况
    checkResizable(rect) {
      let widthType = rect.hasOwnProperty("widthType") ? rect.widthType : "px"
      let heightType = rect.hasOwnProperty("heightType") ? rect.heightType : "px"
      if (widthType !== "px" && heightType !== "px") {
        return false
      }
      return rect.resizable
    },
    checkHandles(rect) {
      // if (!rect.resizable) {
      //   return []
      // }
      let widthType = rect.hasOwnProperty("widthType") ? rect.widthType : "px"
      let heightType = rect.hasOwnProperty("heightType") ? rect.heightType : "px"
      // if (rect.shape !== "cxAutoLayout") {
      //   return ["tl", "tm", "tr", "mr", "br", "bm", "bl", "ml"]
      // }
      if (widthType !== "px" && heightType !== "px") {
        return []
      }
      if (widthType === "px" && heightType !== "px") {
        return ["ml", "mr"]
      }
      if (widthType !== "px" && heightType === "px") {
        return ["tm", "bm"]
      }
      return ["tl", "tm", "tr", "mr", "br", "bm", "bl", "ml"]
    }
  }
}
</script>

<style scoped>
.rowBox {
  overflow: visible;
}
.componentBox {
  width: 100%;
  height: 100%;
  position: relative;
  background-clip: content-box;
}
.componentBox.auto-layout .vdr {
  position: relative;
  transform: translate(0, 0) !important;
}
.componentBox_after {
  position: relative;
  display: table;
}
.componentBox.auto-layout .componentBox_after {
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
}
.componentBox.auto-layout .componentBox_after.horizon,
.componentBox.auto-layout .componentBox_after.horizon .vdr {
  display: inline-block;
}
.componentBox.auto-layout .componentBox_after.vertical {
  min-width: 100%;
}
.componentBox_after::before {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  opacity: var(--background-opacity);
  background-image: var(--background-image);
  background-repeat: var(--background-repeat);
  background-size: var(--background-size);
  background-position: var(--background-position);
}
.ref-line {
  position: absolute;
  background-color: rgb(255, 0, 204);
  z-index: 9999;
}

.v-line {
  width: 1px;
}

.h-line {
  height: 1px;
}
.col {
  flex: none;
}
.last_level_col {
  z-index: 1;
}
.last_level_col:hover {
  z-index: 10000;
}
/*设置尾页几个按钮的对齐方式*/
.componentBox_after.displayFlex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.componentBox_after.displayFlex .vdr {
  position: relative;
  transform: none !important;
  margin-bottom: 24px;
}
.componentBox_after.displayFlex .vdr:last-child {
  margin-left: auto;
}
.auto-layout-container {
  position: absolute;
  top: 0;
  left: 0;
  /*max-width: 100%;*/
  /*max-height: 100%;*/
  overflow: hidden;
}
.row > * {
  padding: 0;
}
.emptyColText {
  display: table-cell;
  vertical-align: middle;
  color: var(--thirdTextColor);
  font-size: 14px;
  text-align: center;
}
/*克隆模式下的样式*/
.col-clone-shade {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: rgba(81, 46, 255, 0.1);
  border: 2px solid #512eff;
  cursor: pointer;
}
.col-clone-shade:hover,
.col-clone-shade.checked {
  background: rgba(81, 46, 255, 0.1);
}
.col-clone-shade .icon {
  position: absolute;
  top: 8px;
  left: 8px;
  font-size: 22px;
  cursor: pointer;
}
.col-clone-shade .select-icon {
  display: inline-block;
  border-radius: 3px;
  width: 20px;
  height: 20px;
  background-color: #fff;
  border: 2px solid #512eff;
}
.col-clone-shade .icon-portal-check-small {
  display: inline-block;
  border-radius: 3px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background-color: #512eff;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
}
.col-clone-shade .select-icon-round {
  display: inline-block;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  background-color: #fff;
  border: 2px solid #512eff;
}
.col-clone-shade .icon-check-round {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  text-align: center;
  background-color: #512eff;
  font-family: Arial;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  border: solid 1px #ffffff;
  letter-spacing: -2px;
}
::v-deep .last_level_col:hover .btn-switch {
  display: block !important;
}
.active-col {
  z-index: 10000;
}
</style>
